import styled from 'styled-components/macro';
import { ADAPTIVE } from '@yme/tokens/screen';
import { FrameInnerStyled, DeviceFrameBg, ImagePreview } from './styled';
export const MobileFrameInnerStyled = styled(FrameInnerStyled) `
  align-self: flex-start;
  padding-top: 35px;
  width: 328px;

  ${ADAPTIVE.minWidth.tablet} {
    padding-top: initial;
    align-self: auto;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 660px;
    width: 255px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    width: 312px;
  }
`;
export const MobileImagePreview = styled(ImagePreview) `
  ${ADAPTIVE.minWidth.tablet} {
    height: 428px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    height: 520px;
  }

  & > div {
    ${ADAPTIVE.minWidth.tablet} {
      margin-top: 9px;
    }
  }

  & img {
    width: 275px;
    height: 452px;
    border-radius: 20px;
    margin: 0 auto;

    ${ADAPTIVE.minWidth.tablet} {
      width: 198px;
      height: 418px;
    }

    ${ADAPTIVE.minWidth.desktop} {
      width: 238px;
      height: 510px;
      margin-top: 10px;
    }
  }
`;
export const MobileDeviceFrameBg = styled(DeviceFrameBg) `
  width: 529px;
  background-position: 0 175px;
  margin-left: 91px;

  ${ADAPTIVE.minWidth.tablet} {
    width: 369px;
    height: 593px;
    background-position: center 0;
    margin-left: -27px;
    margin-top: 100px;
  }

  ${ADAPTIVE.minWidth.desktop} {
    width: 380px;
    height: 731px;
    background-position: center 0;
    margin-left: 0px;
    margin-top: 128px;
  }
`;
